import { $api } from '@service/RequestService';
import { useQuery } from 'react-query';

import { excelConstructorConstants, excelConstructorModels } from '..';

export const useExcelConstructorGenerateCount = ({
  onSuccess,
  enabled = true,
  ...props
}: excelConstructorModels.IExcelConstructorGenerate & { enabled?: boolean; onSuccess?: (data: number) => void }) =>
  useQuery<number>({
    queryKey: [excelConstructorConstants.queryKeys.EXCEL_CONSTRUCTOR_GENERATE_COUNT, props],
    queryFn: async () => {
      const res = await $api.post('/v1/excel-constructor/generate/count', props);

      return res?.data?.data;
    },
    enabled: enabled && !!props.templateId,
    onSuccess: data => {
      if (onSuccess) {
        onSuccess(data);
      }
    }
  });
